/**
 * @generated SignedSource<<77709f69ba7bd909e4af812344808ce0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ManageSignatureCertificateModal_createDigitalSigningCertificate_Mutation$variables = {
  password: string;
  singleUse?: boolean | null;
};
export type ManageSignatureCertificateModal_createDigitalSigningCertificate_Mutation$data = {
  readonly createDigitalSigningCertificate: {
    readonly digitalSigningCertificateCreated: {
      readonly email: string;
      readonly id: string;
      readonly name: string;
      readonly pfx: string;
      readonly validFrom: {
        readonly utcDatetime: ISO8601DateTimeString;
      };
      readonly validUntil: {
        readonly utcDatetime: ISO8601DateTimeString;
      };
    };
    readonly sessionInfo: {
      readonly digitalSigningCertificates: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly email: string;
            readonly name: string;
            readonly pfx: string;
            readonly validFrom: {
              readonly utcDatetime: ISO8601DateTimeString;
            };
            readonly validUntil: {
              readonly utcDatetime: ISO8601DateTimeString;
            };
          } | null;
        }>;
      } | null;
    };
  } | null;
};
export type ManageSignatureCertificateModal_createDigitalSigningCertificate_Mutation = {
  response: ManageSignatureCertificateModal_createDigitalSigningCertificate_Mutation$data;
  variables: ManageSignatureCertificateModal_createDigitalSigningCertificate_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "password"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "singleUse"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "password",
        "variableName": "password"
      },
      {
        "kind": "Variable",
        "name": "singleUse",
        "variableName": "singleUse"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pfx",
  "storageKey": null
},
v6 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "utcDatetime",
    "storageKey": null
  }
],
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "DateTime",
  "kind": "LinkedField",
  "name": "validFrom",
  "plural": false,
  "selections": (v6/*: any*/),
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "DateTime",
  "kind": "LinkedField",
  "name": "validUntil",
  "plural": false,
  "selections": (v6/*: any*/),
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "MemberDigitalSigningCertificate",
  "kind": "LinkedField",
  "name": "digitalSigningCertificateCreated",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/),
    (v4/*: any*/),
    (v5/*: any*/),
    (v7/*: any*/),
    (v8/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ManageSignatureCertificateModal_createDigitalSigningCertificate_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SignaturesCreateDigitalSigningCertificateMutationPayload",
        "kind": "LinkedField",
        "name": "createDigitalSigningCertificate",
        "plural": false,
        "selections": [
          (v9/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SessionInfo",
            "kind": "LinkedField",
            "name": "sessionInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MemberDigitalSigningCertificateConnection",
                "kind": "LinkedField",
                "name": "digitalSigningCertificates",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MemberDigitalSigningCertificateEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MemberDigitalSigningCertificate",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/),
                          (v5/*: any*/),
                          (v7/*: any*/),
                          (v8/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ManageSignatureCertificateModal_createDigitalSigningCertificate_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SignaturesCreateDigitalSigningCertificateMutationPayload",
        "kind": "LinkedField",
        "name": "createDigitalSigningCertificate",
        "plural": false,
        "selections": [
          (v9/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SessionInfo",
            "kind": "LinkedField",
            "name": "sessionInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MemberDigitalSigningCertificateConnection",
                "kind": "LinkedField",
                "name": "digitalSigningCertificates",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MemberDigitalSigningCertificateEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MemberDigitalSigningCertificate",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/),
                          (v5/*: any*/),
                          (v7/*: any*/),
                          (v8/*: any*/),
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d65573811a71b4216de0ec6c22995508",
    "id": null,
    "metadata": {},
    "name": "ManageSignatureCertificateModal_createDigitalSigningCertificate_Mutation",
    "operationKind": "mutation",
    "text": "mutation ManageSignatureCertificateModal_createDigitalSigningCertificate_Mutation(\n  $password: String!\n  $singleUse: Boolean\n) {\n  createDigitalSigningCertificate(input: {password: $password, singleUse: $singleUse}) {\n    digitalSigningCertificateCreated {\n      id\n      name\n      email\n      pfx\n      validFrom {\n        utcDatetime\n      }\n      validUntil {\n        utcDatetime\n      }\n    }\n    sessionInfo {\n      digitalSigningCertificates {\n        edges {\n          node {\n            name\n            email\n            pfx\n            validFrom {\n              utcDatetime\n            }\n            validUntil {\n              utcDatetime\n            }\n            id\n          }\n        }\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ab07660d8bdafb0f631a5a0bd9479247";

export default node;
